import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setWorkerTimeClock } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";

export interface SetWorkerTimeClockInput {
	workerId: string;
	timeClockEnabled: boolean;
}

export function useSetWorkerTimeClock() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (input: SetWorkerTimeClockInput) =>
			setWorkerTimeClock(
				activeCanteiroId as string,
				input.workerId,
				input.timeClockEnabled,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["workers"] });
			queryClient.invalidateQueries({ queryKey: ["time-entries"] });
			queryClient.invalidateQueries({ queryKey: ["attendance"] });
		},
	});
}
